module.exports = __webpack_public_path__ + "assets/img/banner-5.cec2877f.png";